<template>
  <div class="form-container">
    <h1 class="mb-4">測定機器情報編集</h1>
    <form @submit.prevent="handleSubmit" @keydown.enter.prevent>
      <div class="mb-3">
        <label for="deviceName" class="form-label">測定機器名 <span class="badge text-bg-danger">必須</span></label>
        <input v-model="device.device_nm" type="text" placeholder="測定機器名" class="form-control" id="deviceName" required>
        <div v-if="errorMessages.device_nm" class="alert alert-danger mt-2">{{ errorMessages.device_nm[0] }}</div>
      </div>

      <div class="mb-3">
        <label for="manufacuturer" class="form-label">製造者 <span class="badge text-bg-danger">必須</span></label>
        <input v-model="device.manufacuturer" type="text" placeholder="製造者" class="form-control" id="manufacuturer" required>
        <div v-if="errorMessages.manufacuturer" class="alert alert-danger mt-2">{{ errorMessages.manufacuturer[0] }}</div>
      </div>

      <div class="mb-3">
        <label for="modelName" class="form-label">型式 <span class="badge text-bg-danger">必須</span></label>
        <input v-model="device.model_nm" type="text" placeholder="型式" class="form-control" id="modelName" required>
        <div v-if="errorMessages.model_nm" class="alert alert-danger mt-2">{{ errorMessages.model_nm[0] }}</div>
      </div>

      <div class="mb-3">
        <label for="serialNomber" class="form-label">製造番号 <span class="badge text-bg-danger">必須</span></label>
        <input v-model="device.serial_no" type="text" placeholder="製造番号" class="form-control" id="serialNomber" required>
        <div v-if="errorMessages.serial_no" class="alert alert-danger mt-2">{{ errorMessages.serial_no[0] }}</div>
      </div>

      <div class="mb-3">
        <label for="specification" class="form-label">仕様 <span class="badge text-bg-danger">必須</span></label>
        <input v-model="device.specification" type="text" placeholder="仕様" class="form-control" id="specification" required>
        <div v-if="errorMessages.specification" class="alert alert-danger mt-2">{{ errorMessages.specification[0] }}</div>
      </div>

      <div class="mb-3">
        <label for="price" class="form-label">価格</label>
        <input v-model="device.price" type="text" placeholder="価格" class="form-control" id="price">
        <div v-if="errorMessages.price" class="alert alert-danger mt-2">{{ errorMessages.price[0] }}</div>
      </div>

      <div class="mb-3">
        <label for="lastUpdDt" class="form-label">最終更新日</label>
        <input v-model="device.last_upd_dt" type="date" placeholder="最終更新日" class="form-control" id="lastUpdDt">
        <div v-if="errorMessages.last_upd_dt" class="alert alert-danger mt-2">{{ errorMessages.last_upd_dt[0] }}</div>
      </div>

      <div class="btn-area">
        <a class="btn btn-secondary mx-1" @click="$router.back()">戻る</a>
        <button type="submit" class="btn btn-success mx-1">更新</button>
      </div>
    </form>
  </div>
</template>

<script>
import { ref, onMounted, watchEffect } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import { getDevice, updateDevice } from '@/api/axios';

export default {
  setup() {
    const title = ref('測定機器情報編集');

    watchEffect(() => {
      document.title = title.value;
    });

    const device = ref({
      device_nm: '',
      manufacuturer: '',
      model_nm: '',
      serial_no: '',
      specification: '',
      price: '',
      last_upd_dt: ''
      // 他のフィールド
    });

    // エラーメッセージ用のリアクティブプロパティ
    const errorMessages = ref({});

    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const deviceId = route.params.id; // URLから測定機器情報IDを取得

    const loadDeviceData = async () => {
      try {
        const response = await getDevice(deviceId);
        device.value = response.data;
      } catch (error) {
        console.error('測定機器情報データの取得に失敗しました:', error);
      }
    };

    const handleSubmit = async () => {
      try {
        await updateDevice(deviceId, device.value);
        store.commit('setFlashMessage', {message: '測定機器情報更新完了！', type: 'success'});
        router.push(`/devices/${deviceId}`);
      } catch (error) {
        if (error.response && error.response.data) {
          // エラーメッセージをerrorMessagesにセット
          errorMessages.value = error.response.data || {};
        }
        store.commit('setFlashMessage', {message: '測定機器情報更新失敗！', type: 'danger'});
        console.error('更新エラー:', error);
      }
    };

    onMounted(loadDeviceData);

    return {
      title,
      device,
      handleSubmit,
      errorMessages
    };
  }
};
</script>

<style scoped>
.form-container {
  width: 70%;
  padding: 20px 20px 80px 20px;
  margin: auto;
  border: 1px solid #ddd;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

input[type="text"],
input[type="email"],
input[type="password"] {
  width: 100%;
  padding: 10px;
  margin-bottom: 20px;
  border: 1px solid #ddd;
  border-radius: 5px;
}

.btn-area{
  text-align: center;
}
</style>
